@if (facade.callMoneyAlternatives$ | async; as callMoneyAlternatives) {
  <div class="tile">
    <div class="zero-text p-bigger-med">{{ 'asset-class-overview.etf-overview.call-money-alternatives.headline' | transloco }}</div>
    <div class="d-block d-sm-flex justify-content-between gap-half mt-3 flex-wrap">
      @for (alternative of callMoneyAlternatives; track $index) {
        <div class="alternative mb-2 mb-md-0" [routerLink]="[instrumentDetailsPage, alternative.isin]">
          <div class="d-flex justify-content-between">
            <div
              class="zero-text p-small-med"
              [ngbTooltip]="
                (alternative.type === 'OVERNIGHT_MONEY'
                  ? 'asset-class-overview.etf-overview.call-money-alternatives.alternative.interestRateTooltip'
                  : 'asset-class-overview.etf-overview.call-money-alternatives.alternative.fixedDepositRateTooltip'
                ) | transloco
              "
            >
              @if (alternative.type === 'OVERNIGHT_MONEY') {
                {{ 'asset-class-overview.etf-overview.call-money-alternatives.alternative.interestRate' | transloco }}
              } @else if (alternative.type === 'FIXED_DEPOSIT_EUR') {
                {{ 'asset-class-overview.etf-overview.call-money-alternatives.alternative.fixedDepositRate' | transloco }}
              }
            </div>
            <div class="zero-text p-small-bold course-green">{{ alternative.interestRate | number }} %</div>
          </div>
          <div class="mt-2 mb-2">
            <div class="zero-text p-xsmall-reg label">
              {{ 'asset-class-overview.etf-overview.call-money-alternatives.alternative.type.' + alternative.type | transloco }}
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <div class="zero-text p-xsmall-reg">
              {{ 'asset-class-overview.etf-overview.call-money-alternatives.alternative.provider' | transloco }}:
            </div>
            <div class="zero-text p-xsmall-med">{{ alternative.issuer ? alternative.issuer : '&mdash;' }}</div>
          </div>
          <div class="d-flex justify-content-between">
            <div class="zero-text p-xsmall-reg">
              {{ 'asset-class-overview.etf-overview.call-money-alternatives.alternative.duration' | transloco }}:
            </div>
            <div class="zero-text p-xsmall-med">{{ alternative.duration ? (alternative.duration | date) : '&mdash;' }}</div>
          </div>
        </div>
      }
    </div>
  </div>
}
